/** The uppercase mono label the onboarding forms put above a group of controls. */
export function FieldGroupLabel({
	id,
	children,
	className = "mb-2",
	as: Element = "span",
}: {
	id?: string;
	children: React.ReactNode;
	className?: string;
	/** `legend` when it names the `fieldset` it sits in. */
	as?: "span" | "legend";
}) {
	return (
		<Element
			id={id}
			className={`block p-0 font-mono text-xs font-semibold uppercase tracking-wider text-dashboard-muted ${className}`}
		>
			{children}
		</Element>
	);
}

/** A short line of help under a field. */
export function FieldHint({
	children,
	tone = "muted",
	id,
}: {
	children: React.ReactNode;
	tone?: "muted" | "error";
	id?: string;
}) {
	return (
		<p
			id={id}
			className={`mt-1.5 font-body text-[13px] ${
				tone === "error" ? "text-dashboard-danger" : "text-dashboard-muted"
			}`}
		>
			{children}
		</p>
	);
}
